
<template class="">
  <nav class="pf ov ba z2000 pv10">
    <div class="ph30 m_ph20 r">
      <div class="g_nm p15 round smBtn"><Icon icon="solar:global-bold" width="20" height="20" class="cc pointer" @click="changeLang()" /></div>
      <div class="g_nm p15 round smBtn ml10"><Icon icon="solar:hamburger-menu-bold" width="20" height="20" class="cc pointer" @click="toggleSidebar()" /></div>
    </div>
  </nav>
  <div class="dashboardBg  mainDiv sideBarActive" :style="{ backgroundImage: 'url(' + require('@/assets/imgs/pattern.svg') + ')' }">
    <router-view></router-view>
  </div>
  <nav class="sidebar"  :class="!isMobile ? 'active' : ''" id="sidebar">
    <div class="ov15 la bbs h m_sb"><Icon icon="solar:close-circle-bold" width="30" height="30" class="pointer cw z1" @click="closeSideBar()" /></div>
    <header><div class="image-text"><span class="image"><img src="@/assets/imgs/logoV1.png" alt="Logo" class="w100" style="max-width: 140px;"></span></div></header>
    <div class="menu-bar">
      <div class="menu">
        <ul class="menu-links">
          <li class="nav-link">
              <router-link :class="this.$route.name == 'Dashboard' ? 'active' : ''" :to="{ name: 'Dashboard' }" @click="closeSideBar()">
                  <Icon icon="solar:home-bold"  class="mr10 ml10 cw" width="25" height="25"/>
                  <span class="text nav-text">{{ $t('Dashboard') }}</span>
              </router-link>
          </li>
          <!-- FUNDS -->
          <li   class="nav-link"> 
            <router-link :class="this.$route.name == 'Funds' ? 'active' : ''" :to="{ name: 'Funds' }" @click="closeSideBar()">
              <Icon icon="solar:wallet-money-bold" class="mr10 ml10 cw"  width="25" height="25"/>
              <span class="text nav-text pr25">{{ $t('Funds') }}</span>
            </router-link>
          </li>
          <!-- PCAKAGES -->
          <!-- <li class="nav-link"> 
            <router-link :class="this.$route.name == 'Packages' ? 'active' : ''" :to="{ name: 'Packages' }" @click="closeSideBar()">
              <Icon icon="fluent:handshake-24-filled" class="mr10 ml10 cw"  width="25" height="25"/>
              <span class="text nav-text pr25">{{ $t('TrendsShif package') }}</span>
            </router-link>
          </li> -->
          <li class="nav-link"> 
            <router-link :class="this.$route.name == 'OrdersAndBillings' ? 'active' : ''" :to="{ name: 'OrdersAndBillings' }" @click="closeSideBar()">
              <Icon icon="material-symbols-light:order-approve" class="mr10 ml10 cw"  width="25" height="25"/>
              <span class="text nav-text pr25">{{ $t('Orders & Billings') }}</span>
            </router-link>
          </li>
          <!-- TEAM -->
          <!-- <li  v-if="user.subscription && user.subscription.status === 'subscribed'" class="nav-link">  -->
          <li class="nav-link"> 
            <router-link :class="this.$route.name == 'Team' ? 'active' : ''" :to="{ name: 'Team' }" @click="closeSideBar()">
              <Icon icon="material-symbols-light:group" class="mr10 ml10 cw"  width="25" height="25"/>
              <span class="text nav-text pr25">{{ $t('Team') }}</span>
            </router-link>
          </li>
          <li  class="nav-link"> 
            <router-link :class="this.$route.name == 'Ranks' ? 'active' : ''" :to="{ name: 'Ranks' }" @click="closeSideBar()">
              <Icon icon="game-icons:rank-3" class="mr10 ml10 cw"  width="25" height="25"/>
              <span class="text nav-text pr25">{{ $t('Ranks') }}</span>
            </router-link>
          </li>
          <li  class="nav-link"> 
            <router-link :class="this.$route.name == 'DashboardMemberships' ? 'active' : ''" :to="{ name: 'DashboardMemberships' }" @click="closeSideBar()">
              <Icon icon="material-symbols:card-membership" class="mr10 ml10 cw"  width="25" height="25"/>
              <span class="text nav-text pr25">{{ $t('Memberships') }}</span>
            </router-link>
          </li>
          
          <li  class="nav-link pointer" :class="this.$route.name == 'PackageIndex' ? 'active' : ''" id="package_link" v-if="package_list?.length>0" @click="showPackgeList()"> 
            <Icon icon="fluent:handshake-24-filled" class="mr10 ml10 cw"  width="25" height="25"/>
            <span class="text nav-text pr25">{{ $t('Packages') }}  </span>
            <svg  xmlns="http://www.w3.org/2000/svg" class="ov15 ba la cw chevronIcon" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </li>
          <div class="package_div pl10">
            <li v-for="el  in package_list" :key="el.id" class="nav-link" >
              <router-link class="pl15"  :class="this.$route.name == 'PackageIndex' && this.$route.params.id == el.id ? 'active' : ''"   :to="{ name: 'PackageIndex', params: { id: el.id } }"  @click="closeSideBar()">
                <span class="text nav-text pr25">{{ $i18n.locale=='en'? el?.name_en : el.name_ar }}</span>
              </router-link>
            </li>
          </div>
          <!-- <li  class="nav-link pointer" :class="this.$route.name == 'PackageIndex' ? 'active' : ''" id="memebrship_link" v-if="memberships_list?.length>0" @click="showMemebershipList()"> 
            <Icon icon="material-symbols:card-membership" class="mr10 ml10 cw"  width="25" height="25"/>
            <span class="text nav-text pr25">{{ $t('Memberships') }}  </span>
            <svg  xmlns="http://www.w3.org/2000/svg" class="ov15 ba la cw chevronIcon" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </li>
          <div class="memebrship_div pl10">
            <li v-for="el  in memberships_list" :key="el.id" class="nav-link" >
              <router-link class="pl15"  :class="this.$route.name == 'PackageIndex' && this.$route.params.id == el.id ? 'active' : ''"   :to="{ name: 'PackageIndex', params: { id: el.id } }"  @click="closeSideBar()">
                <span class="text nav-text pr25">{{ $i18n.locale=='en'? el?.name_en : el.name_ar }}</span>
              </router-link>
            </li>
          </div> -->
          
          <li  v-if="user.subscription && user.subscription.status == 'subscribed' && available" class="nav-link"> 
              <Icon icon="emojione-monotone:money-bag" class="mr10 ml10 cw"  width="25" height="25"/>
              <span class="text nav-text pr25">{{ $t('Commession/Profit') }}</span>
          </li>
          <li  v-else class="nav-link op40 not-allowed"> 
              <Icon icon="emojione-monotone:money-bag" class="mr10 ml10 cw"  width="25" height="25"/>
              <span class="text nav-text pr25">{{ $t('Commession/Profit') }}</span>
              <i class='fas fa-lock fs20 cw  ov mt15 mr5  la' v-if="user.subscription?.status !='subscribed' || !available"></i>
          </li>
        </ul>
      </div>
      <div class="bottom-content">
        <li class="">
              <router-link :class="this.$route.name == 'Profile' ? 'active' : ''" :to="{ name: 'Profile' }" @click="closeSideBar()">
            <Icon icon="gg:profile" class="mr10 ml10 cw"  width="25" height="25"/>
            <span class="text nav-text">{{ user.first_name }}</span>
          </router-link>
        </li>
        <li class="logoutBtn pointer round" @click="logout()">
          <Icon icon="streamline:logout-1-solid" class="mr10 ml10 cw"  width="25" height="25"/>
          <span class="text nav-text">{{ $t('Logout')}}</span>
        </li>
      </div>
    </div>
  </nav>
  <div v-if="$store.state.loader==1 || $store.state.pageLoader==1" class="pf ov bgw" style="z-index: 9999999;"><div class="cc"><div class="loader">$</div></div></div>
  <div v-if="$store.state.formLoader==1" class="pf ov bgb40" style="z-index: 9999999;"><div class="cc"><div class="loader">$</div></div></div>
</template>
<script>

export default {
    name: "UserLayout",
    data() {
      return {
        user: {},
        at:null,
        isMobile:false,
        available:false,
        package_list:[],
        memberships_list:[],
      }
    },
    created(){
      
      this.isMobile = window.innerWidth <= 768;
      if(this.$cookies.isKey("_TrendLang")){
        if(this.$cookies.get("_TrendLang")=='en'){this.$i18n.locale='ar';}
        else{this.$i18n.locale='en';}
        this.changeLang()
      }
      if(this.$cookies.isKey("_TrendsU") && this.$cookies.isKey("_TrendsAT") ){
        this.user=this.$cookies.get("_TrendsU");
        this.at=this.$cookies.get("_TrendsAT")
        this.at = this.at.replace(/^"|"$/g, '');
        this.axios.get(this.$store.state.BaseApiURL + 'client/get-packages-types',{
          headers: {
            'Authorization': `Bearer ${this.at}`
          }
        }).then((response) => {
          this.package_list=response.data.data;
        }).catch((error) => {
          console.log(error);
        });
        this.axios.get(this.$store.state.BaseApiURL + 'get-memberships',{
          headers: {
            'Authorization': `Bearer ${this.at}`
          }
        }).then((response) => {
          this.memberships_list=response.data.data;
        }).catch((error) => {
          console.log(error);
        });
      }
      else{this.$router.push({ name: 'SignIn'});}
    },
    methods:{
      showPackgeList(){
        if($('#package_link').hasClass('active')){
          $('.package_div').slideUp();
          $('#package_link').removeClass('active')
        }
        else{
          $('.package_div').slideDown();
          $('#package_link').addClass('active')
        }
      },
      showMemebershipList(){
        if($('#memebrship_link').hasClass('active')){
          $('.memebrship_div').slideUp();
          $('#memebrship_link').removeClass('active')
        }
        else{
          $('.memebrship_div').slideDown();
          $('#memebrship_link').addClass('active')
        }
      },
      toggleSidebar() {
        $('#sidebar').toggleClass('active')
        $('.mainDiv').toggleClass('sideBarActive')
      },
        logout(){
          this.$cookies.remove("_TrendsU")
          this.$cookies.remove("_TrendsAT")
          this.$cookies.remove("_TrendsCC")
          this.$router.push({ name: 'Home'}); 
        },
        closeSideBar(){
        if(this.isMobile){
          $('#sidebar').removeClass('active')
          $('.mainDiv').removeClass('sideBarActive')
        }
        },
      changeLang(){
        if(this.$i18n.locale=="en"){
          $('html').attr('lang', 'ar');  
          this.$i18n.locale='ar';
          $('body').addClass('rtl');
          const expirationTime =  10000 * 60 * 60;
          this.$cookies.set("_TrendLang", 'ar', expirationTime);
        }
        else{
          $('html').attr('lang', 'en');  
          this.$i18n.locale='en';
          $('body').removeClass('rtl');
          const expirationTime =  10000 * 60 * 60;
          this.$cookies.set("_TrendLang", 'en', expirationTime);
        }
      },
    },
    
  }
  
</script>
<style scoped>


body:not(.rtl) .sidebar {
    position: fixed;
    top: 0;
    left: -270px;
    height: 100%;
    width: 270px;
    padding: 10px;
    background: #2B2B2B;
    transition: all 0.3s ease;
    z-index: 2000;
}
body.rtl .sidebar {
    position: fixed;
    top: 0;
    right: -270px;
    height: 100%;
    width: 270px;
    padding: 10px;
    background: #2B2B2B;
    transition: all 0.3s ease;
    z-index: 2000;
}

body:not(.rtl) .sidebar.active{
left:0px
}
body.rtl .sidebar.active {
    right:0px;
}
.sidebar li {
    height: 50px;
    list-style: none;
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.sidebar header .image{
    min-width: 60px;
    border-radius: 6px;
}



.sidebar .text{
    color: #FFF;
    transition: all 0.3s ease;
}

.sidebar .text {
    font-size: 17px;
    font-weight: 500;
    white-space: nowrap;
    opacity: 1;
}

.sidebar.xclose .text {
    opacity: 0;
}

.sidebar header {
    position: relative;
}

.sidebar header .image-text {
    display: flex;
    align-items: center;
}

.sidebar header .logo-text {
    display: flex;
    flex-direction: column;
}

header .image-text .name {
    margin-top: 2px;
    font-size: 18px;
    font-weight: 600;
}

header .image-text .profession {
    font-size: 16px;
    margin-top: -2px;
    display: block;
}

.sidebar header .image {
    display: flex;
    align-items: center;
    justify-content: center;
}


.sidebar .menu {
    margin-top: 40px;
}

.sidebar li a {
    list-style: none;
    height: 100%;
    background-color: transparent;
    display: flex;
    align-items: center;
    height: 100%;
    width: 100%;
    border-radius: 6px;
    text-decoration: none;
    transition: all 0.3s ease;
}

.sidebar li a:hover,.logoutBtn:hover {
    background-color: #EC6D2025;
}

.sidebar li a.active {
    background-color: #EC6D2050;
}

.sidebar .menu-bar {
    height: calc(100% - 55px);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: scroll;
}

.menu-bar::-webkit-scrollbar {
    display: none;
}

.bottom-content {
    border-top: 1px solid #ffffff30;
}
.package_div{
  display: none;
}
#package_link.active, #package_link:hover {
  background-color: #EC6D2050;
  border-radius: 6px;
}
#package_link.active+.package_div{
  display: block;
}
.chevronIcon{
  transition: transform 0.3s ease;
}
#package_link.active .chevronIcon{
  transform: rotate(180deg);
}
.memebrship_div{
  display: none;
}
#memebrship_link.active, #memebrship_link:hover {
  background-color: #EC6D2050;
  border-radius: 6px;
}
#memebrship_link.active+.memebrship_div{
  display: block;
}
.chevronIcon{
  transition: transform 0.3s ease;
}
#memebrship_link.active .chevronIcon{
  transform: rotate(180deg);
}
</style>